import { Injectable } from '@angular/core';
import {Country} from '../interfaces/countryData';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient) { }

  getCountries() {
      return this.http.get<any>('assets/country.json')
      .toPromise()
      .then(res => <Country[]>res.data)
      .then(data => { return data; });
  }
}
